"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcurrentStatistics = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const server_1 = require("../../../server");
const common_1 = require("../../../common");
const Container = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 20px 90px;
	gap: 40px;
`;
const Card = styled_components_1.default.div `
	width: 443px;
	height: 80px;
	background: #fff;
	border: 1px solid #e6e8ed;
	border-radius: 10px;
	gap: 75px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	font-weight: 700;
	font-family: 'Noto Sans KR', sans-serif;
`;
// const mockConcurrentItems: ConcurrentItem[] = Array.from({ length: 20 }, (_, idx) => ({
//     title: `샘플 클래스 #${idx + 1}`,
//     count: Math.floor(Math.random() * 30) + 1, // 1~30명 랜덤
// }));
exports.ConcurrentStatistics = react_1.default.memo(react_1.default.forwardRef(({ refreshRate }, ref) => {
    const count = 10;
    const [page, setPage] = react_1.default.useState(0);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [membersSum, setMembersSum] = (0, react_1.useState)(0);
    const [concurrentItems, setConcurrentItems] = (0, react_1.useState)([]);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'siteName', space: 1 },
            { title: 'className', space: 2 },
            { title: 'concurrentCount', space: 1 },
        ];
        const tableReadDataKeys = [
            { title: 'tenant_id', space: 1 },
            { title: 'title', space: 2 },
            { title: 'count', space: 1 },
        ];
        return { headTitleList, tableReadDataKeys };
    }, []);
    const { data, refetch } = (0, server_1.useConcurrentStatistics)({
        offset: page * count,
        limit: count,
    });
    const refetchRef = react_1.default.useRef(refetch);
    refetchRef.current = refetch;
    // 렌더마다 throttle 인스턴스가 재생성되어 스로틀이 무효화되던 것 수정 — 단일 인스턴스 유지
    const refetchList = react_1.default.useMemo(() => (0, throttle_1.default)(() => refetchRef.current(), 1000, { leading: true, trailing: false }), []);
    // Expose refresh method to parent
    react_1.default.useImperativeHandle(ref, () => ({
        refresh: refetchList,
    }));
    (0, react_1.useEffect)(() => {
        refetchList();
    }, [page]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, found_count, items, members_sum } = data;
            setMembersSum(members_sum);
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / count) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존으로 빈 화면·페이지네이션 소실).
                setTotalCount(0);
                setConcurrentItems([]);
                return;
            }
            setTotalCount(total_count);
            const concurrentItems = items.map((item) => ({
                tenant_id: item.tenant_id,
                title: item.title,
                count: item.count,
            }));
            setConcurrentItems(concurrentItems);
        }
    }, [data, page]);
    (0, react_1.useEffect)(() => {
        if (refreshRate === 0)
            return;
        // Auto refresh interval
        const interval = setInterval(() => {
            refetchList();
        }, refreshRate * 1000);
        return () => clearInterval(interval);
    }, [refreshRate, refetchList]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uC811\uC18D\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, (() => {
            switch (headItem.title) {
                default:
                    return react_1.default.createElement("p", { className: "overText2", style: {
                            WebkitLineClamp: 1,
                        } }, item[headItem.title]);
            }
        })())));
    };
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Card, null,
            react_1.default.createElement("div", null, "\uC2E4\uC2DC\uAC04 \uD3EC\uD138 \uC811\uC18D \uC778\uC6D0"),
            react_1.default.createElement("div", null,
                membersSum,
                "\uBA85")),
        react_1.default.createElement(common_1.Table, { className: `header-center`, showIndex: true, indexOrder: "desc", isInnerPage: true, isInfinite: false, page: page, data: concurrentItems, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData })));
}));
